import { render, staticRenderFns } from "./BiodataNia.vue?vue&type=template&id=7255d86a&"
import script from "./BiodataNia.vue?vue&type=script&lang=js&"
export * from "./BiodataNia.vue?vue&type=script&lang=js&"
import style0 from "./BiodataNia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports